import { ReactElement } from 'react';

import {
  SmallScholarship,
  LargeScholarship,
} from '@backrs_ui/common-ui/src/molecules/Nugget/NuggetScholarship/types';

import { NuggetScholarshipLarge } from './NuggetScholarshipLarge';
import { NuggetScholarshipSmall } from './NuggetScholarshipSmall';

type NuggetScholarshipProps = Readonly<{
  variant: SmallScholarship | LargeScholarship;
  contentSize?: 'SMALL' | 'LARGE';
}>;

export const NuggetScholarship = ({
  variant,
  contentSize,
}: NuggetScholarshipProps): ReactElement | null => {
  if (variant.type === 'SMALL') {
    return <NuggetScholarshipSmall variant={variant} contentSize={contentSize} />;
  }

  return <NuggetScholarshipLarge scholarshipInfo={variant.scholarshipInfo} />;
};
